<template>
  <div class="relative overflow-hidden flex flex-col items-center rounded-2xl bg-brand-dark-gray px-5 py-5 ring-1 ring-white/10">
    <div class="pointer-events-none absolute inset-x-0 top-0 h-24 bg-gradient-to-b from-brand-lime/10 to-transparent"/>
    <div class="relative flex flex-col w-full items-center space-y-5">
      <div class="flex flex-col items-center space-y-2 text-center">
        <div class="text-brand-lime text-xs font-semibold tracking-[0.14em] uppercase">Pineapple Premium</div>
        <div class="text-white text-xl font-medium leading-snug">Unlock the full experience</div>
        <div class="text-brand-light-gray text-base leading-relaxed">
          Unlimited reveals, messaging, galleries, profile views, and event hosting.
        </div>
      </div>
      <in-app-subscription class="w-full" label="Upgrade to Pineapple Premium">
        <template v-slot:body>
          <button
              class="mx-auto w-full flex bg-brand-lime rounded-full px-8 h-12 font-medium text-xl text-brand-black transition-all active:scale-[0.99]">
            <div class="flex m-auto">Go Premium</div>
          </button>
        </template>
      </in-app-subscription>
    </div>
  </div>
</template>
<script setup lang="ts">
import InAppSubscription from "@/components/InAppSubscription.vue";
</script>
